$(document).ready(function() {

    // Lazy load images
    $('.lazy').each(function() {
        var $self = $(this);

        function updateIframe(iframe) {
            var $iframe = $(iframe.target);
            $iframe.attr('src', $iframe.data('src'));
            $iframe.removeClass('lazy')
        }

        function updateImage(image) {
            var $image = $(image.target);
            var attrs = ['src', 'srcset', 'sizes'];
            for (var len = attrs.length, i = 0; i < len; i++) {
                var attr = attrs[i];
                if ($image.data(attr)) {
                    $image.attr(attr, $image.data(attr));
                    $image.removeAttr('data-' + attr);
                }
            }
            $image.removeClass('lazy')
        }

        function updateBackImage(image) {
            var $image = $(image.target);
            if ($image.data('src')) {
                $image.css('background-image', 'url("'+ $image.data('src') + '")')
            }
            $image.removeClass('lazy')
        }

        if (!$self.data('offset')) {
            $self.data('offset', 400);
        }

        if ($self.is('img')) {
            $self.one('inview', updateImage)
        } else if ($self.is('iframe')) {
            $self.one('inview', updateIframe)
        } else if ($self.data('src')) {
            // background-image
            $self.one('inview', updateBackImage)
        } else {
            // Find images and load src useful for slick carousel
            $self.one('inview', function() {
                $(this).find('img').each(updateImage)
            })

        }
    });

});
